<template>
    <div>
        <div v-if="calendarShow">
            <van-calendar title="活动日历" :poppable="false"
                :show-confirm="false" :formatter="formatter"
                @select="onSelected" :style="{ height: '800px' }" />
         </div>
        <van-popup v-model="contentShow" position="bottom" :style="{ height: '55%' }">
            <van-panel :title="contentTitle" :desc="contentDesc" :status="contentStatus">
                <div style="margin-left:10px;margin-right:10px;line-height:200%;text-align:left;font-size:14px">
                    <div>{{contentMain}}</div>
                    <div class="van-hairline--bottom"></div>
                    <div style="text-align:center">具体活动安排,请参阅工会相关邮件</div>
                </div>
            </van-panel>
        </van-popup>
    </div>
</template>
<script>
import axios from 'axios';
import { Calendar, Popup, Panel } from 'vant';

export default {
    name: 'EventCalendar',
    data () {
        return {
            calendarShow: false,
            contentShow: false,
            contentTitle: '',
            contentDesc: '',
            contentMain: '',
            contentStatus: '进行中',
            allEvents: []
        }
    },
    mounted() {
        let vm = this;
        console.log("Load event data...");
        axios.get('/api/eventcalendar').then((res) => {
          //console.log(res.data);
          vm.allEvents = res.data;
          vm.calendarShow = true;
        }).catch((error) => {
          alert("Internal server error!");
          vm.allEvents = [];
          vm.calendarShow = true;
        });
    },
    methods: {
        formatDate(date) {
            let m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return `${date.getFullYear()}-${m}-${d}`;
        },
        formatter(day) {
            let fDate = this.formatDate(day.date);
            day.type = 'disabled';

            let i;
            for (i = 0; i < this.allEvents.length; i ++) {
                if (fDate == this.allEvents[i].dt) {
                    day.topInfo = '☆';
                    day.bottomInfo = this.allEvents[i].shortname;
                    day.type = 'selected';
                    //console.log("one selected event!");
                }
            }

            return day;
        },
        onSelected(day) {
            const year = day.getFullYear();
            const month = day.getMonth() + 1;
            const date = day.getDate();
            let fDate = this.formatDate(day);

            let i;
            for (i = 0; i < this.allEvents.length; i ++) {
                if (fDate == this.allEvents[i].dt) {
                    this.contentTitle = this.allEvents[i].title;
                    this.contentDesc = this.allEvents[i].desc;
                    this.contentMain = this.allEvents[i].main;
                    let today = new Date();
                    let m = today.getMonth() + 1;
                    let d = today.getDate();
                    if (m === month && d === date) {
                        this.contentStatus = "进行中";
                    } else if ((m < month) || (m === month && d < date)) {
                        this.contentStatus = "报名中";
                    } else if ((m > month) || (m === month && d > date)) {
                        this.contentStatus = "已结束";
                    }
                    break;
                }
            }

            this.contentShow = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/EventCalendar.vue